import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'
import AddDiscount from './AddDiscount'
import LoginRequest from './LoginRequest'

function DiscountRates(props) {
  props.stopListRefresh()
  const [isOpen, setIsOpen] = useState(false)
  //const [isloggedIn, setIsloggedIn] = useState(true);
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  /* useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

  const togglePopUp = async () => {
    setIsOpen(!isOpen)
  }
  const removeData = async (index) => {
    var rowIndex = index + 1
    var cellIndex = 0
    var data =
      document.getElementById('discountTable').rows[rowIndex].cells[cellIndex]
        .innerHTML
    var discountTime = Number(data.replace('min', ''))
    try {
      await axios.delete(`${SERVER_URI}/remove_discount_rate/${discountTime}`, {
        headers: { Authorization: `Token ${userToken}` },
      })
    } catch (e) {
      console.log('Error in deleting the discount', e)
    }
    props.dispatch({ type: 'DELETE_DISCOUNT', data: { discountIndex: index } })
  }

  return (
    <div className='configurations'>
      {isOpen && (
        <AddDiscount dispatch={props.dispatch} handleClose={togglePopUp} />
      )}
      <h3>Voimassa olevat Alennusprosentit</h3>
      <span>
        <div className='discountRates'>
          <button id='lightBlue_button' onClick={togglePopUp}>
            Lisää alennus{' '}
          </button>
          {props.discountRatesList === undefined ? (
            <LoginRequest />
          ) : props.discountRatesList.length === 0 ? (
            <h4>Ei voimassa olevia alennuksia</h4>
          ) : (
            <table id='discountTable'>
              <thead>
                <tr>
                  <th>Aika minuutteina</th>
                  <th>Alennusprosentti</th>
                </tr>
              </thead>
              <tbody>
                {props.discountRatesList
                  .sort((a, b) =>
                    a.time > b.time ? 1 : b.time > a.time ? -1 : 0
                  )
                  .map((discountRate, index) => (
                    <tr key={index} id={discountRate.id}>
                      <td>{Number(discountRate.time)} min </td>
                      <td>{discountRate.discount} %</td>

                      <td className='opration'>
                        <button onClick={() => removeData(index)}>
                          Poista
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </span>
    </div>
  )
}

export default DiscountRates
